import { GridURLParam } from '../models/grid.model';
import { pickNonEmptyKeys } from './objectData';

export const parseURLParam = (paramsData: GridURLParam | any) => {
  const params = pickNonEmptyKeys(paramsData);
  let URLParams = '';

  if (params && Object.keys(params).length !== 0) {
    URLParams = Object.keys(params).reduce((acc: any, key: string, idx: number) => {
      if ((params as any)?.[key]) {
        acc += `${idx === 0 ? '?' : '&'}${key}=${(params as any)[key]}`;
      }
      return acc;
    }, '');
  }

  return URLParams;
};